import { Action } from '@ngrx/store';
import { Contact } from '@app/model/contact.model';

export const UPSERT = '[CONTACT_PROFILE] UPSERT';
export const CLEAR = '[CONTACT_PROFILE] CLEAR';
export const PATCH = '[CONTACT_PROFILE] PATCH';
export const PATCH_FAIL = '[CONTACT_PROFILE] PATCH FAIL';
export const PATCH_SUCCESS = '[CONTACT_PROFILE] PATCH SUCCESS';
export const PATCH_RESET = '[CONTACT_PROFILE] PATCH RESET';
export const SET_ERROR = '[CONTACT_PROFILE] SET ERROR';
export const CHANGE_PASSWORD = '[CONTACT_PROFILE] CHANGE PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = '[CONTACT_PROFILE] CHANGE PASSWORD SUCCESS';
export const CHANGE_PASSWORD_FAIL = '[CONTACT_PROFILE] CHANGE PASSWORD FAIL';

// New Profile API actions
export const GET_PROFILE = '[CONTACT_PROFILE] GET PROFILE';
export const GET_PROFILE_SUCCESS = '[CONTACT_PROFILE] GET PROFILE SUCCESS';
export const GET_PROFILE_FAIL = '[CONTACT_PROFILE] GET PROFILE FAIL';

export const UPDATE_PROFILE = '[CONTACT_PROFILE] UPDATE PROFILE';
export const UPDATE_PROFILE_SUCCESS = '[CONTACT_PROFILE] UPDATE PROFILE SUCCESS';
export const UPDATE_PROFILE_FAIL = '[CONTACT_PROFILE] UPDATE PROFILE FAIL';

export const ACCEPT_TERMS_AND_CONDITIONS = '[CONTACT_PROFILE] ACCEPT TERMS AND CONDITIONS';
export const ACCEPT_TERMS_AND_CONDITIONS_SUCCESS = '[CONTACT_PROFILE] ACCEPT TERMS AND CONDITIONS SUCCESS';
export const ACCEPT_TERMS_AND_CONDITIONS_FAIL = '[CONTACT_PROFILE] ACCEPT TERMS AND CONDITIONS FAIL';

export class Upsert implements Action {
    readonly type = UPSERT;
    constructor(public payload: any) {
    }
}

export class Clear implements Action {
    readonly type = CLEAR;
    constructor() {
    }
}

export class Patch implements Action {
    readonly type = PATCH;
    constructor(public payload: any, public profileId: string, public contact: Contact) {
    }
}

export class PatchFail implements Action {
    readonly type = PATCH_FAIL;
    constructor(public payload: any) {
    }
}

export class PatchSuccess implements Action {
    readonly type = PATCH_SUCCESS;
    constructor(public payload: any) {
    }
}

export class SetError implements Action {
    readonly type = SET_ERROR;
    constructor(public payload: string[]) {
    }
}

export class ChangePassword implements Action {
    readonly type = CHANGE_PASSWORD;
    constructor(public payload: { oldPassword: string; newPassword: string }) {
    }
}

export class ChangePasswordSuccess implements Action {
    readonly type = CHANGE_PASSWORD_SUCCESS;
    constructor(public payload: any) {
    }
}

export class ChangePasswordFail implements Action {
    readonly type = CHANGE_PASSWORD_FAIL;
    constructor(public payload: any) {
    }
}

// New Profile API action classes
export class GetProfile implements Action {
    readonly type = GET_PROFILE;
    constructor() {
    }
}

export class GetProfileSuccess implements Action {
    readonly type = GET_PROFILE_SUCCESS;
    constructor(public payload: any) {
    }
}

export class GetProfileFail implements Action {
    readonly type = GET_PROFILE_FAIL;
    constructor(public payload: any) {
    }
}

export class UpdateProfile implements Action {
    readonly type = UPDATE_PROFILE;
    constructor(public payload: any) {
    }
}

export class UpdateProfileSuccess implements Action {
    readonly type = UPDATE_PROFILE_SUCCESS;
    constructor(public payload: any) {
    }
}

export class UpdateProfileFail implements Action {
    readonly type = UPDATE_PROFILE_FAIL;
    constructor(public payload: any) {
    }
}

export class AcceptTermsAndConditions implements Action {
    readonly type = ACCEPT_TERMS_AND_CONDITIONS;
    constructor() {
    }
}

export class AcceptTermsAndConditionsSuccess implements Action {
    readonly type = ACCEPT_TERMS_AND_CONDITIONS_SUCCESS;
    constructor(public payload: any) {
    }
}

export class AcceptTermsAndConditionsFail implements Action {
    readonly type = ACCEPT_TERMS_AND_CONDITIONS_FAIL;
    constructor(public payload: any) {
    }
}

export type ContactProfileActions = Upsert
| Clear
| SetError
| Patch
| PatchFail
| PatchSuccess
| ChangePassword
| ChangePasswordSuccess
| ChangePasswordFail
| GetProfile
| GetProfileSuccess
| GetProfileFail
| UpdateProfile
| UpdateProfileSuccess
| UpdateProfileFail
| AcceptTermsAndConditions
| AcceptTermsAndConditionsSuccess
| AcceptTermsAndConditionsFail;
